module.exports = __webpack_public_path__ + "static/media/home_phone2.6854b8fd.png";